











































































































































































import Vue from 'vue';
import ShipInput from '@/components/fleet/ShipInput.vue';
import AirStatusResultBar from '@/components/result/AirStatusResultBar.vue';
import FleetDetail from '@/components/fleet/FleetDetail.vue';
import Const from '@/classes/const';
import Fleet from '@/classes/fleet/fleet';
import Ship from '@/classes/fleet/ship';
import SiteSetting from '@/classes/siteSetting';

export default Vue.extend({
  name: 'Fleet',
  components: {
    ShipInput,
    AirStatusResultBar,
    FleetDetail,
  },
  props: {
    value: {
      type: Fleet,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    handleShowShipList: {
      type: Function,
      required: true,
    },
    handleShowItemList: {
      type: Function,
      required: true,
    },
    handleShowTempShipList: {
      type: Function,
      required: true,
    },
    handleShowItemPreset: {
      type: Function,
      required: true,
    },
    unionFleet: {
      type: Fleet,
    },
    isUnion: {
      type: Boolean,
      default: false,
    },
    admiralLv: {
      type: Number,
      default: 120,
    },
  },
  data: () => ({
    formations: Const.FORMATIONS,
    cellTypes: Const.CELL_TYPES,
    detailDialog: false,
    destroyDialog: false,
    lastTab: 'stage2',
    isShipView2Line: false,
  }),
  mounted() {
    const setting = this.$store.state.siteSetting as SiteSetting;
    this.isShipView2Line = setting.isShipView2Line;
  },
  computed: {
    fleet() {
      return this.value;
    },
    contactRate() {
      if (this.isUnion && this.index <= 1 && this.unionFleet) {
        return this.unionFleet.getContactRates(true)[0].sumRate.toFixed(1);
      }
      return this.value.getContactRates()[0].sumRate.toFixed(1);
    },
    nightContactRate() {
      if (this.isUnion && this.index <= 1 && this.unionFleet) {
        return (100 * this.unionFleet.nightContactRate).toFixed(1);
      }
      return (100 * this.value.nightContactRate).toFixed(1);
    },
    fleetScouts(): number[] {
      if (this.isUnion && this.index <= 1 && this.unionFleet) {
        return this.unionFleet.getUnionScoutScore(this.admiralLv).map((v) => Math.floor(100 * v) / 100);
      }
      return Fleet.getScoutScore(this.fleet.ships, this.admiralLv).map((v) => Math.floor(100 * v) / 100);
    },
    shipAddEnabled() {
      return this.value.ships.length < 7;
    },
    shipRemoveEnabled() {
      return this.value.ships.length > 1;
    },
    tpA() {
      if (this.isUnion && this.index <= 1 && this.unionFleet) {
        return Math.floor(this.unionFleet.tp * 0.7);
      }
      return Math.floor(this.value.tp * 0.7);
    },
    actualFleet(): Fleet {
      if (this.isUnion && this.index <= 1 && this.unionFleet) {
        return this.unionFleet;
      }
      return this.value;
    },
  },
  methods: {
    showItemList(shipIndex: number, slotIndex: number) {
      // 艦娘indexを解決してFleetAll.vueへパス
      this.handleShowItemList(this.index, shipIndex, slotIndex);
    },
    showShipList(index: number) {
      this.handleShowShipList(this.index, index);
    },
    showTempShipList(shipIndex: number) {
      this.handleShowTempShipList(this.index, shipIndex);
    },
    showItemPreset(shipIndex: number) {
      this.handleShowItemPreset(this.index, shipIndex);
    },
    async clickedInfo() {
      this.destroyDialog = false;
      await (this.detailDialog = true);
      (this.$refs.fleetDetail as InstanceType<typeof FleetDetail>).tab = this.lastTab;
    },
    updateShip() {
      if (document.getElementById('dragging-item')) {
        // ドラッグ交換中はここで伝播キャンセルする
        return;
      }
      this.setFleet();
    },
    setFleet(fleet?: Fleet) {
      if (fleet === undefined) {
        this.$emit('input', new Fleet({ fleet: this.fleet }));
      } else {
        this.$emit('input', fleet);
      }
    },
    resetFleet() {
      // 初期化
      const ships = [];
      for (let i = 0; i < 6; i += 1) {
        ships.push(new Ship());
      }
      this.setFleet(new Fleet({ fleet: this.fleet, ships }));
    },
    removeShip(index: number) {
      const ships = this.fleet.ships.concat();
      if (ships.length) {
        ships[index] = new Ship();
        this.setFleet(new Fleet({ fleet: this.fleet, ships }));
      } else {
        // 消せなかったらリセット処理と同じで
        this.resetFleet();
      }
    },
    removeLastShip() {
      // 念のため数チェック
      if (this.fleet.ships.length > 1) {
        const end = this.fleet.ships.length - 1;
        this.setFleet(new Fleet({ fleet: this.fleet, ships: this.fleet.ships.slice(0, end) }));
      }
    },
    addEmptyShip() {
      this.fleet.ships.push(new Ship());
      this.setFleet(new Fleet({ fleet: this.fleet }));
    },
    toggleDetailDialog() {
      if (!this.detailDialog) {
        this.lastTab = (this.$refs.fleetDetail as InstanceType<typeof FleetDetail>).tab;
        setTimeout(() => {
          this.destroyDialog = true;
        }, 100);
      } else {
        this.destroyDialog = false;
      }
    },
    closeDetail() {
      this.detailDialog = false;
      this.toggleDetailDialog();
    },
    toggleViewLine(value: boolean) {
      const setting = this.$store.state.siteSetting as SiteSetting;
      setting.isShipView2Line = value;
      this.$store.dispatch('updateSetting', setting);
    },
  },
});
